<ng-template #estadoTpl let-valor let-row="row">
  <span class="r182-estado" [class.r182-estado--error]="valor > 0">
    <mat-icon>{{ valor > 0 ? 'error' : 'check_circle' }}</mat-icon>
    {{ valor > 0 ? valor + (valor === 1 ? ' error' : ' errores') : 'Correcto' }}
  </span>
</ng-template>

<ng-template #origenTpl let-valor let-row="row">
  <span class="r182-origen r182-origen--{{ valor | lowercase }}">
    {{ valor === 'CALCULADO' ? 'Calculado' : valor === 'IMPORTADO' ? 'Importado' : 'Manual' }}
  </span>
</ng-template>

<ng-template #importeTpl let-valor let-row="row">
  <span class="r182-importe">
    {{ formatoImporte(valor) }}
    <button type="button" class="r182-help" *ngIf="row.origen === 'CALCULADO'" (click)="origen.emit(row.indice)"
      matTooltip="Ver de dónde sale este importe">?</button>
  </span>
</ng-template>

<div class="cf-table-card">
  <app-custom-table #table="customTable" [config]="tableConfig"></app-custom-table>
</div>
